module.exports = __webpack_public_path__ + "img/splant_mosaic.5aef68e7.jpg";